import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, get } from "firebase/database";
import "./NonCapAdmissions.css";
import DescriptionIcon from "@mui/icons-material/Description";
import {
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box
} from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

const FREE_LIMIT = 5;

const NonCapAdmissions = () => {

  const [data, setData] = useState([]);
  const [openCollege, setOpenCollege] = useState(null);
  const [openYear, setOpenYear] = useState(null);

  const [premium, setPremium] = useState(false);
  const [showPremium, setShowPremium] = useState(false);
  const [videoOpen, setVideoOpen] = useState(false);

  // =============================
  // CHECK PREMIUM
  // =============================
  useEffect(() => {
    const uid = localStorage.getItem("uid");
    if (!uid) return;

    get(ref(db, "users/" + uid)).then((snap) => {
      if (snap.exists()) {
        setPremium(snap.val().is_premium === true);
      }
    });
  }, []);

  // =============================
  // LOAD COLLEGES (SAFE STRUCTURE)
  // =============================
  useEffect(() => {
    const collegesRef = ref(db, "colleges");

    get(collegesRef).then((snapshot) => {
      if (!snapshot.exists()) return;

      const raw = snapshot.val();

      const formatted = Object.keys(raw).map(id => {

        const college = raw[id];

        // 🔥 HANDLE BOTH STRUCTURES
      let yearsData = {
  "2025": { pdfs: {} },
  "2026": { pdfs: {} }
};

// If proper years exist
if (college.years && typeof college.years === "object") {
  yearsData = {
    "2025": college.years["2025"] || { pdfs: {} },
    "2026": college.years["2026"] || { pdfs: {} }
  };
}

// If old structure (pdfs directly)
else if (college.pdfs) {
  yearsData = {
    "2025": { pdfs: college.pdfs },
    "2026": { pdfs: {} }
  };
}


        return {
          id,
          name: college.name || "College",
          years: yearsData
        };
      });

      setData(formatted);
    });
  }, []);

  // =============================
  // OPEN PDF
  // =============================
  const openPdf = (url, index) => {

    if (!premium && index === FREE_LIMIT) {
      setShowPremium(true);
      return;
    }

    if (!url || typeof url !== "string") {
      alert("PDF link not available.");
      return;
    }

    if (!url.startsWith("http")) {
      alert("Invalid PDF URL.");
      return;
    }

    window.open(url, "_blank");
  };

  // =============================
  // RENDER
  // =============================
  return (
    <div className="noncap-container">

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          marginBottom: "16px"
        }}
      >
        <h3 style={{ color: "#1d4ed8", margin: 0 }}>
          NON-CAP Admissions
        </h3>

        <Tooltip title="Watch Tutorial">
          <IconButton color="info" onClick={() => setVideoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </div>

      {/* COLLEGE LIST */}
      {data.map((college, cIndex) => {

        const collegeOpen = openCollege === cIndex;

        return (
          <div key={college.id} className="college-card">

            {/* COLLEGE HEADER */}
            <div
              className="college-header"
              onClick={() =>
                setOpenCollege(collegeOpen ? null : cIndex)
              }
            >
              <span>{college.name}</span>
              <span>{collegeOpen ? "▲" : "▼"}</span>
            </div>

            {/* YEARS */}
            {collegeOpen && Object.keys(college.years).map(year => {

              const yearKey = `${cIndex}-${year}`;
              const isYearOpen = openYear === yearKey;

              const pdfs =
                college.years &&
                college.years[year] &&
                college.years[year].pdfs
                  ? Object.values(college.years[year].pdfs)
                  : [];

              return (
                <div key={year}>

                  {/* YEAR FOLDER */}
                  <div
                    className="year-folder"
                    onClick={() =>
                      setOpenYear(isYearOpen ? null : yearKey)
                    }
                  >
                    📁 {year}
                  </div>

                  {/* PDF LIST */}
                  {isYearOpen && (
                    <div className="pdf-list">

                      {/* EMPTY YEAR */}
                      {pdfs.length === 0 && (
                        <div className="uploading-soon">
                          to be uploaded soon...
                        </div>
                      )}

                      {pdfs.length > 0 &&
                        pdfs
                          .slice(
                            0,
                            premium
                              ? pdfs.length
                              : Math.min(FREE_LIMIT + 1, pdfs.length)
                          )
                          .map((pdf, index) => {

                            const locked =
                              !premium && index === FREE_LIMIT;

                            if (locked) {
                              return (
                                <div
                                  key={index}
                                  className="unlock-btn"
                                  onClick={() => setShowPremium(true)}
                                >
                                  🔒 Unlock All PDFs – Enroll Now
                                </div>
                              );
                            }

                            return (
                              <div
  key={index}
  className="pdf-item"
  onClick={() => openPdf(pdf.url, index)}
  style={{ display: "flex", alignItems: "center", gap: "8px" }}
>
  <DescriptionIcon fontSize="small" color="action" />
  {pdf.title || "Document"}
</div>
                            );
                          })}
                    </div>
                  )}

                </div>
              );
            })}

          </div>
        );
      })}

      {/* VIDEO TUTORIAL */}
      <Dialog
        open={videoOpen}
        onClose={() => setVideoOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }}
>
  <Typography
    sx={{
      fontSize: {
        xs: "14px",   // mobile
        sm: "18px",   // tablet
        md: "20px"    // desktop
      },
      fontWeight: 600
    }}
  >
    Non-CAP Admissions – Tutorial Guide
  </Typography>

  <IconButton
  onClick={() => setVideoOpen(false)}
  sx={{
    transform: {
      xs: "scale(0.9)",
      sm: "scale(1)"
    }
  }}
>
  <CloseIcon />
</IconButton>
</DialogTitle>

        <DialogContent dividers sx={{ p: 0 }}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              paddingTop: "56.25%",
              backgroundColor: "#000"
            }}
          >
            <iframe
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0
              }}
              src="https://player.vimeo.com/video/1166301129?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              title="Non-CAP Admissions Tutorial"
              allowFullScreen
            />
          </Box>
        </DialogContent>
      </Dialog>

      {/* PREMIUM MODAL */}
      {showPremium && (
        <div className="modal-backdrop">
          <div className="modal">
            <h3>Access Required</h3>
            <p>Enroll in Counselling Program to unlock all documents.</p>

           <div className="modal-actions">

  <button
    className="popup-primary-btn"
    onClick={() =>
      window.location.href = "/counselling-program"
    }
  >
    Enroll Now
  </button>

  <button
    className="popup-secondary-btn"
    onClick={() => setShowPremium(false)}
  >
    Cancel
  </button>

</div>

          </div>
        </div>
      )}

    </div>
  );
};

export default NonCapAdmissions;
